import * as xlsx from "xlsx";
const $inject = ['$q', 'dataService', 'pointsOfInterestService', '$timeout', '$rootScope', '$scope', 'lbaLeafletMapService', 'Upload'];

function dateTimeString(int) {
  if (String(int).length === 1) return '0' + int;

  return String(int);
}

const lbaPointsOfInterestCtrl = function ($q, dataService, pointsOfInterestService, $timeout, $rootScope, $scope, lbaLeafletMapService, Upload) {
  let vm = this;
  let debtorsEndpoint = 'Debtors';
  let pointsOfInterestEndpoint = 'PointOfInterests';
  vm.filename = '';
  vm.errorText = '';

  vm.detailActive = false;

  vm.refreshDebtors = refreshDebtors;
  vm.getPointsOfInterest = getPointsOfInterest;
  vm.toggleDetail = toggleDetail;
  vm.editItem = editItem;
  vm.newItem = newItem;
  vm.saveItem = saveItem;
  vm.deleteItem = deleteItem;
  vm.exportExcel = exportExcel;
  vm.importExcel = importExcel;
  vm.activateItem = activateItem;
  vm.toggleItemActive = toggleItemActive;
  vm.activeItem = {};

  vm.blobUrl = blobUrl;
  vm.progressPercentage = 0;
  vm.uploadSuccess = false;
  vm.uploadFailure = false;
  vm.uploading = false;
  let zeroAddresses = [];
  const ExcelData = [];
  let colWidths = [];

  vm.pointsOfInterestColumns = [
    {
      name: 'DebtorIdentifier',
      dataAt: 'DebtorIdentifier',
    },
    {
      name: 'Title',
      dataAt: 'Title',
    },
    {
      name: 'Description',
      dataAt: 'Description',
    },
    {
      name: 'Address',
      dataAt: 'Address',
    },
    {
      name: 'Latitude',
      dataAt: 'Latitude',
    },
    {
      name: 'Longitude',
      dataAt: 'Longitude',
    },
  ];

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });

  function getPosition(address, i) {
    var defer = $q.defer();
      lbaLeafletMapService.getPosByAddress(address, i)
      .then((data) => {
        defer.resolve(data);
      })
      .catch((status) => {
        if (status == 'ZERO_RESULTS') {
          defer.resolve();
          zeroAddresses.push(i + 2);
          console.log(`Problem recognising address for row ${i + 2} -`, address);
        }
        else {
          defer.reject(status);
          console.log('Error getting position', status);
        }
      });
    return defer.promise;
  }

  function activateItem(item) {
    $rootScope.$emit('leaflet.highlight', item);
    toggleItemActive(item);
  }

  function toggleItemActive(item, digest) {
    vm.activeItem.active = false;
    vm.activeItem = item;

    if (digest) {
      $scope.$apply(function () {
        item.active = true;
      });
    } else {
      item.active = true;
    }
  }

  function toggleDetail() {
    vm.detailActive = !vm.detailActive;
  }

  function editItem(item) { // toggle form
    vm.activePointOfInterest = item;
    vm.detailActive = true;
  }

  function newItem() { // toggle form
    vm.activePointOfInterest = null;
    vm.detailActive = true;
  }

  function exportExcel() {
    vm.progressPercentage = 0;
    vm.uploadSuccess = false;
    vm.uploadFailure = false;

    vm.resource.rows.forEach((row, i) => {
      const dataItem = {
        id: i + 1,
      };
      vm.resource.columns.forEach((col) => {
        let colData = _.get(row, col.dataAt);
        colWidths.push({ width: 25 });
        dataItem[col.name] = colData;

      });
      ExcelData.push(dataItem);
    });
    finalizeExport();
  }

  function finalizeExport() {
    try {
      if (ExcelData && ExcelData.length > 0) {
        const ws = xlsx.utils.json_to_sheet(ExcelData);
        ws["!cols"] = [...Array(Object.keys(ExcelData[0]).length)].map(() => {
          return { width: 25 };
        });
        const wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, ws, 'points-of-interest');
        xlsx.writeFile(
          wb,
          `${vm.debtor.Name}-points-of-interest.xlsx`
        );
      }
    } catch (e) {
      console.log("export error", e);
    }
  }

  vm.upload = function (file) {
    vm.uploadFailure = false;

    if (!file) {
      vm.uploadFailure = true;
      return false;
    }

    Upload.upload({
      url: `${endPointUrl}/api/Upload/PointOfInterestBatchUpload?filename=${vm.filename}`,
      data: { file: file }
    }).then(function () {
      vm.uploading = false;
      vm.uploadSuccess = true;
    }, function (resp) {
      vm.uploading = false;
      vm.uploadSuccess = false;
      vm.uploadFailure = true;
      console.log('Error status: ' + resp.status);
    }, function (evt) {
      vm.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
    });
  };

  function importExcel(file) {
    vm.progressPercentage = 0;
    vm.uploading = false;
    vm.uploadSuccess = false;
    vm.uploadFailure = false;

    if (!file) {
      return;
    }

    let fileExtension = file.name.substr(file.name.lastIndexOf('.'));
    let fileName;
    let fileNameDate = new Date();

    fileName = dateTimeString(fileNameDate.getFullYear());
    fileName += dateTimeString(fileNameDate.getMonth() + 1);
    fileName += dateTimeString(fileNameDate.getDate()) + '_';
    fileName += dateTimeString(fileNameDate.getHours());
    fileName += dateTimeString(fileNameDate.getMinutes());

    fileName = vm.debtor.Name + '_' + fileName + '_poi_import';
    
    fileName += fileExtension;

    vm.filename = fileName;

    var reader = new FileReader();
    let output = [];
    reader.onload = function (e) {
      vm.uploading = true;
      zeroAddresses = [];
      try {
        var data = e.target.result;
        var wb = xlsx.read(data, {
          type: "binary",
        });
        var getPositionPromises = [];
        wb.SheetNames.forEach((sheetName) => {
          output = xlsx.utils
            .sheet_to_json(wb.Sheets[sheetName])
            .map((item, i) => {
              const obj = {};
              vm.pointsOfInterestColumns.forEach((col) => {
                if (col.name == 'Latitude' && item[col.name] == null) {
                  var promise = getPosition(item['Address'], i).then((position) => {
                    _.set(obj, 'Latitude', position ? position.lat : null);
                    _.set(obj, 'Longitude', position ? position.long : null);
                  });
                  getPositionPromises.push(promise);
                } else {
                  _.set(obj, col.dataAt, item[col.name] || null);
                }
              });
              return obj;
            });
        });

        $q.all(getPositionPromises).then(() => {
          if (zeroAddresses.length > 0) {
            vm.uploading = false;
            vm.uploadFailure = true;
            vm.errorText = zeroAddresses.length > 1 ? `Unrecognised addresses. Please check the following rows: ${zeroAddresses}` 
            : `Unrecognised address. Please check row ${zeroAddresses}`;
          } else {
            vm.uploading = false;
            var ws = xlsx.utils.json_to_sheet(output);
            const wb = xlsx.utils.book_new();
            xlsx.utils.book_append_sheet(wb, ws, 'points-of-interest');
            var content = xlsx.write(wb, { type: 'array' });
            var newFile = new File([content], vm.filename, { type: "plain/xlsx" });
            vm.upload(newFile);
          }
        }, function (error) {
          vm.uploading = false;
          vm.uploadFailure = true;
          console.log(error);
        });
      } catch (e) {
        console.warn(e);
      }
    }

    reader.onerror = function (ex) {
      console.warn(ex);
    };

    reader.readAsBinaryString(file);
  }

  function saveItem(item) {
    let deferred = $q.defer();
    pointsOfInterestService.savePointOfInterest(vm.debtor.Name, item)
      .then((success) => {
        getPointsOfInterest(function () {
          deferred.resolve(success);
          $timeout(function () {
            $rootScope.$emit('leaflet.refresh', vm.refreshMap);
          });
        });

      });
    return deferred.promise;
  }


  function deleteItem(itemId) {
    let deferred = $q.defer();
    pointsOfInterestService.deletePointOfInterest({ id: itemId })
      .then((res) => {
        getPointsOfInterest(function () {
          deferred.resolve(res.data);
          $timeout(function () {
            $rootScope.$emit('leaflet.refresh', vm.refreshMap);
          });
        });

      })
      .catch(data => {
        deferred.reject(data);
      });
    return deferred.promise;
  }


  function getPointsOfInterest(cb) {
    loadMap();
    dataService.search({
      endpoint: pointsOfInterestEndpoint,
      searchTerm: vm.debtor.Name,
      searchType: 'DebtorIdentifier',
      expression: null,
      includeDeleted: false
    }).then(result => {
      vm.pointsOfInterest = result;
      vm.resource = {
        columns: vm.pointsOfInterestColumns,
        rows: vm.pointsOfInterest,
        pagination: {
          page: 1,
        }
      };
      $timeout(function () {
        $rootScope.$emit('leaflet.refresh', vm.refreshMap);
      });

      if (typeof cb !== 'undefined') {
        cb();
      }
    });
  }

  function loadMap() {
    vm.showMap = true;
  }

  function refreshDebtors(selected) {
    vm.uploadSuccess = false;
    vm.uploadFailure = false;
    vm.progressPercentage = 0;
    dataService.search({
      endpoint: debtorsEndpoint,
      searchTerm: selected,
      searchType: 'Name',
      expression: 'contains',
      includeDeleted: false,
      selectFields: 'Name'
    }).then(result => {
      vm.debtors = result;
      $timeout(function () {
        $rootScope.$emit('leaflet.refresh', vm.refreshMap);
      });
    });
  }

};

lbaPointsOfInterestCtrl.$inject = $inject;

export default lbaPointsOfInterestCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaPointsOfInterest/lbaPointsOfInterestCtrl.js